let xPosDown: number = 0;
let yPosDown: number = 0;
let xPosUp: number = 0;
let yPosUp: number = 0;
let swipeElement;

export const touchStartHandler = (evt: TouchEvent) => {
	swipeElement = evt.target;
	xPosDown = evt.touches[0].clientX;
	yPosDown = evt.touches[0].clientY;
}

export const touchMoveHandler = (evt: TouchEvent) => {
	if (!xPosDown || !yPosDown) {
		return;
	}

	swipeElement = evt.target;
	xPosUp = evt.touches[0].clientX;
	yPosUp = evt.touches[0].clientY;
}

export const touchEndHandler = (target, onSwipeHandler: () => void) => {
	if (target !== swipeElement) {
		return;
	}
	const distanceX = Math.abs(xPosUp - xPosDown);
	const distanceY = Math.abs(yPosUp - yPosDown);
	const distance = Math.sqrt(Math.pow(distanceX,2) + Math.pow(distanceY, 2));
	if (distance > 10) {
		onSwipeHandler();
	}
}
